"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import styles from './Segment.module.scss.mjs';
import * as Aria from 'react-aria-components';
import clsx from 'clsx';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconCheck } from '../../../Icon/components/icons/IconCheck.mjs';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';
import { ClearPropsContext } from '../../../ClearPropsContext/ClearPropsContext.mjs';

const Segment = flowComponent("Segment", (props) => {
  const { children, className, ref, ...rest } = props;
  const rootClassName = clsx(styles.segment, className);
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsxs(Aria.Radio, { ...rest, className: rootClassName, ref, children: [
    children,
    /* @__PURE__ */ jsx(IconCheck, { className: styles.checkmark })
  ] }) });
});

export { Segment, Segment as default };
//# sourceMappingURL=Segment.mjs.map
